import React from 'react';
import { createPortal } from 'react-dom';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { useToastStore } from '@/store/toast-store';
import styles from './Toast.module.css';

/**
 * Toasts render as a line of handwriting at the page edge (foundation §6) —
 * italic ink, no box, no icons. Clicking a line dismisses it early; otherwise
 * it clears itself after its duration. Error lines take the vermilion pen.
 */
export const ToastContainer: React.FC = () => {
  const toasts = useToastStore((state) => state.toasts);
  const removeToast = useToastStore((state) => state.removeToast);
  const prefersReducedMotion = useReducedMotion();

  const content = (
    <div className={styles.container}>
      <AnimatePresence>
        {toasts.map((toast) => (
          <motion.button
            key={toast.id}
            type="button"
            className={`${styles.toast} ${styles[toast.type] ?? ''}`}
            onClick={() => removeToast(toast.id)}
            aria-label={`${toast.message} — dismiss`}
            initial={prefersReducedMotion ? { opacity: 0 } : { opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={prefersReducedMotion ? { opacity: 0 } : { opacity: 0, y: 8 }}
            transition={{ duration: 0.18, ease: [0.4, 0.0, 0.2, 1] }}
          >
            {toast.message}
          </motion.button>
        ))}
      </AnimatePresence>
    </div>
  );

  return createPortal(content, document.body);
};
